import type { WeaponDefinition, WeaponId } from './types'
import weaponsData from '../../assets/data/weapons.json'

export const WEAPON_DEFINITIONS = weaponsData as unknown as Record<WeaponId, WeaponDefinition>

export const WEAPON_ORDER: WeaponId[] = [
  'basic2p',
  'blade',
  'spread1p',
  'plasma',
  'beamp',
  'miss1p',
  'homing1p',
  'gyrex1p',
  'rail',
  'cannon1p',
  'subdue',
]

